<div>
    <h4 matDialogTitle>Export Gallery</h4>
</div>
<div matDialogContent class="dialog-content">
    <div class="gallery-export" #gallery>
        <div class="gallery-export__header" *ngIf="fileHeader?.length > 0">
            <p>{{ fileHeader }}</p>
        </div>

        <div class="gallery-export__sub-header" *ngIf="fileSubHeader?.length > 0">
            <p>{{ fileSubHeader }}</p>
        </div>

        <div *ngFor="let item of galleryItems" class="gallery-item" [ngClass]="getLayout()">
            <ng-container *ngIf='item'>
            <img [src]="item.image_url" alt=""/>
            <div class="metrics" [ngStyle]="getMetricStyle()" *ngIf="data.filterData.length > 0">
                <span *ngFor="let filter of data.filterData">
                    <small class="font-weight-bold">{{filter.metric_acronym | displayName }}:</small>
                    <small *ngIf="filter.metric_name.endsWith('_v') || filter.metric_name === 'reg_sales'">
                        {{ item[filter.metric_name] | shortNumber}}
                    </small>
                    <small *ngIf="!(filter.metric_name.endsWith('_v') || filter.metric_name === 'reg_sales')">
                        {{ item[filter.metric_name] }}
                    </small>
                </span>
            </div>
            <ng-container [ngSwitch]="getTileStatus(item)">
                <div *ngSwitchCase="'pending'" class="tile-status"></div>
                <div *ngSwitchCase="'loading'" class="tile-status">
                    <mat-spinner [color]="'accent'" [diameter]="28"></mat-spinner>
                </div>
                <mat-icon *ngSwitchCase="'done'"
                          class="tile-badge tile-badge--done"
                          [ngStyle]="getBadgeStyle()">check_circle</mat-icon>
                <mat-icon *ngSwitchCase="'failed'"
                          class="tile-badge tile-badge--failed"
                          [ngStyle]="getBadgeStyle()"
                          matTooltip="This image could not be loaded and will be a grey box in the export">error</mat-icon>
            </ng-container>
            </ng-container>
        </div>
    </div>

    <div class="export-settings">
        <div class="export-settings__layout-selector">
            <mat-form-field>
                <mat-label class="font-weight-bold">Select Layout</mat-label>
                <mat-select [(value)]="selectedConfig" (selectionChange)="setGalleryLayout()" [disabled]="isExporting">
                    <mat-option
                        *ngFor="let config of layoutConfigs"
                        [value]="config">{{config.layout}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="export-settings__file-header">
            <label class="font-weight-bold">Enter header</label>
            <mat-form-field class="w-100">
                <input matInput [(ngModel)]="fileHeader" [disabled]="isExporting"/>
            </mat-form-field>
        </div>

        <div class="export-settings__file-header">
            <label class="font-weight-bold">Enter sub-header</label>
            <mat-form-field class="w-100">
                <input matInput [(ngModel)]="fileSubHeader" [disabled]="isExporting"/>
            </mat-form-field>
        </div>

        <div class="export-settings__page-size-selector">
            <label class="font-weight-bold d-block">Choose page size</label>
            <mat-radio-group [(ngModel)]="selectedPageSize" [disabled]="isExporting">
                <mat-radio-button class="page-size-option"
                                  [value]="pageSize"
                                  *ngFor="let pageSize of pageSizes">{{pageSize.name}}</mat-radio-button>

            </mat-radio-group>
        </div>

        <div class="export-settings__file-type-section">
            <label id="file-type-select-label">Export as</label>
            <mat-radio-group
                aria-labelledby="file-type-select-label"
                class="file-type-selections"
                [(ngModel)]="exportType"
                [disabled]="isExporting">
                <mat-radio-button class="file-type-option" [value]="'PPTX'">PPTX</mat-radio-button>
                <mat-radio-button class="file-type-option" [value]="'PDF'">PDF</mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="export-settings__file-name">
            <label class="font-weight-bold">Enter file name</label>
            <mat-form-field class="w-100">
                <input matInput [(ngModel)]="filename" [disabled]="isExporting"/>
            </mat-form-field>
        </div>

        <p class="export-settings__status" aria-live="polite" *ngIf="isExporting && exportStatus">{{ exportStatus }}</p>

        <div class="export-settings__button-layout">
            <button
                mat-button
                (click)="close()"
                class="btn btn-primary cancel-btn">Cancel</button>

            <button
                *ngIf="exportType === 'PPTX'"
                (click)="exportAsPowerpoint()"
                class="btn btn-primary export-btn"
                [disabled]="isExporting"
            >
                <div class="button-spinner-container" *ngIf="isExporting">
                    <mat-spinner class="mat-spinner" [color]="'accent'" [diameter]="20"></mat-spinner>
                </div>
                <span *ngIf="!isExporting">Export</span>
            </button>

            <button
                *ngIf="exportType === 'PDF'"
                (click)="exportAsPdf()"
                class="btn btn-primary export-btn"
                [disabled]="isExporting"
            >
                <div class="button-spinner-container" *ngIf="isExporting">
                    <mat-spinner class="mat-spinner" [color]="'accent'" [diameter]="20"></mat-spinner>
                </div>
                <span *ngIf="!isExporting">Export</span>
            </button>
        </div>

    </div>
</div>
<div matDialogActions class="d-flex flex-row justify-content-between align-items-center">
    <div class="button-layout">
        <span class="d-flex flex-row justify-content-start align-items-center">
            <p class="font-weight-bold mr-2">Page Count:</p>
            <p>{{ galleryItemsPages?.length }}</p>
        </span>
    </div>
</div>